import { configureStore } from '@reduxjs/toolkit'
import { userReducer } from './user/userReducer'
import { iframeReducer } from './iframe/iframeReducer'

export const store = configureStore({
  reducer: {
    user: userReducer.reducer,
    iframe: iframeReducer.reducer
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
